import { SvgProps } from "../../types";

const Download = (props: SvgProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={15}
    fill="none"
    {...props}>
    <path
      fill="#4C5269"
      strokeWidth={2}
      d="M2.155 15c-.375 0-.703-.14-.984-.422a1.349 1.349 0 0 1-.422-.984v-3.352h1.406v3.352h12.188v-3.352h1.406v3.352c0 .375-.14.703-.422.984-.281.281-.61.422-.984.422H2.155Zm6.094-3.586L3.726 6.891l1.007-1.008 2.813 2.812V0h1.406v8.695l2.813-2.812 1.008 1.008-4.524 4.523Z"
    />
  </svg>
);
export default Download;
